import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';

import { Observable, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

import { ConfigService } from './config.service';

/*

  File up-/download through lambda: How NOT to do it.

  This is a very bad example of file handling.
  Please DO NOT use this for future projects!

*/

export interface RequestFile {
  name?: string;
  fileLinkId?: string;
  id?: string;
  created?: string;
  success?: boolean;
  progress?: number;
}

export type UploadResp =
  | {
      success: boolean;
      name: string;
      id: string;
    }
  | {
      name: string;
      progress: number;
    };
@Injectable({
  providedIn: 'root'
})
export class FileService {
  private http = inject(HttpClient);
  configService = inject(ConfigService);

  uploadFile(file: FormData, linkId: string): Observable<unknown> {
    return this.http.post<unknown>(`${this.configService.getConfiguration().apiHost}/api/upload/${linkId}`, file);
  }

  getLinkedFiles(linkId: string): Observable<RequestFile[]> {
    return this.http
      .get<RequestFile[]>(`${this.configService.getConfiguration().apiHost}/api/file/link/${linkId}`)
      .pipe(
        catchError((error) => {
          console.error('Get linked files error:', error);
          return throwError(() => error);
        })
      );
  }

  getFileById(id: string): Observable<string> {
    return this.http
      .get<{ link: string; success: boolean }>(`${this.configService.getConfiguration().apiHost}/api/file/id/${id}`)
      .pipe(
        map((resp) => {
          if (!resp.success) {
            throw new Error('file not found'); // Throw error inside the pipe
          }
          return resp.link;
        }),
        catchError((error) => {
          console.error('Get file by ID error:', error);
          return throwError(() => error);
        })
      );
  }

  deleteFileById(id: string): Observable<boolean> {
    return this.http
      .delete<{ success: boolean }>(`${this.configService.getConfiguration().apiHost}/api/file/id/${id}`)
      .pipe(
        map(() => {
          return true;
        }),
        catchError((error) => {
          console.error('Delete file error:', error);
          return throwError(() => error);
        })
      );
  }
}
